export default function langToLongISO (lang) {
  switch (lang) {
    case 'cs': return 'cs-CZ'
    case 'ro': return 'ro-RO'
    case 'sk': return 'sk-SK'
    case 'hr': return 'hr-HR'
    case 'pl': return 'pl-PL'
    default: return lang
  }
}
